import { Base } from "@/atoms-react/text/Text.react.tsx";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react.tsx";
import { useTranslation } from "react-i18next";
import Loader from "@/atoms-react/loader/Loader.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react";
import type { bronzeCategories } from "@/features/user/quiz/types";
import { useState } from "react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const OtherSourceIncomes = ({
  setFormResponseOSI,
  setFormResponseOSIComment,
  othersourceIncomes,
  sourceIncomeItems,
  isLoadingSourcesIncome,
  commentProps
}: {
  setFormResponseOSI: (sourceIncome: bronzeCategories, isChecked: boolean) => void;
  othersourceIncomes: string[];
  sourceIncomeItems: bronzeCategories[];
  isLoadingSourcesIncome: boolean;
  commentProps: string | null;
  setFormResponseOSIComment: (comment: string, valueChecked: boolean) => void;
}) => {
  const { t } = useTranslation(["pass"]);
  const [comment, setComment] = useState<string | null>(commentProps);

  const codeOfOtherIncome = sourceIncomeItems?.find((item) => item.code === 10);
  const { getLanguage } = usei18n();

  const handleCheckboxChange = (sourceIncome: bronzeCategories, isChecked: boolean) => {
    setFormResponseOSI(sourceIncome, isChecked);
  };

  const handleCommentChange = (value: string) => {
    setComment(value);
    setFormResponseOSIComment(
      value,
      othersourceIncomes.includes(codeOfOtherIncome?.code.toString() as string)
    );
  };
  return (
    <>
      {isLoadingSourcesIncome && (
        <div className="mt-4 mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}
      {!isLoadingSourcesIncome && (
        <div className="flex w-full flex-col" data-cy="other-assets-categories">
          <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
            {sourceIncomeItems &&
              [...sourceIncomeItems.filter((item) => item.code !== 10), codeOfOtherIncome].map(
                (c) => (
                  <Checkbox
                    key={c?.code}
                    value={
                      othersourceIncomes &&
                      othersourceIncomes.some((income) => Number(income) === Number(c?.code))
                    }
                    onChange={(value) => handleCheckboxChange(c as bronzeCategories, value)}
                  >
                    <Base className="mb-1 cursor-pointer">
                      {getLanguage() === "fr" ? c?.name : c?.english_name}
                    </Base>
                  </Checkbox>
                )
              )}
          </div>
          {othersourceIncomes &&
            codeOfOtherIncome &&
            othersourceIncomes.includes(codeOfOtherIncome?.code.toString()) && (
              <div className={"mt-4 mb-4"}>
                <InputLabel
                  onChange={(value: string) => handleCommentChange(value)}
                  value={comment as string}
                  className="mb-1 w-full flex-1 md:mb-0"
                  placeholder={t(
                    "olkypass.mainPage.olkypass.BronzeForms.other_ressources_placeholder"
                  )}
                />
              </div>
            )}
        </div>
      )}
    </>
  );
};
